import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
  DataRoomFolderBrowseDocument,
  DataRoomFolderBrowseQuery,
  DataRoomFolderBrowseQueryVariables,
} from "@/src/graphql/generated";
import useGqlClient from "@/src/hooks/useGqlClient";

const STALE_TIME = 60_000;

export function usePrefetchDataRoomFolderBrowse(
  folderId: string,
  delayMs = 150,
) {
  const client = useGqlClient();
  const queryClient = useQueryClient();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clear = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => clear, []);

  const prefetch = () => {
    if (!folderId) {
      return;
    }

    void queryClient.prefetchQuery({
      queryKey: ["DataRoomFolderBrowse", { id: folderId }],
      queryFn: () =>
        client.request<
          DataRoomFolderBrowseQuery,
          DataRoomFolderBrowseQueryVariables
        >(DataRoomFolderBrowseDocument, { id: folderId }),
      staleTime: STALE_TIME,
    });
  };

  return {
    onMouseEnter: () => {
      clear();
      timerRef.current = setTimeout(prefetch, delayMs);
    },
    onMouseLeave: clear,
    onFocus: prefetch,
  };
}
